import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import LoadingText from '../LoadingText';
import { isMac } from '../../utils';
const useStyles = makeStyles((theme) => ({
    root: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: (props) => (props.electronCaptionMode ? 102 : 800),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: (props) => (props.electronCaptionMode ? 30 : 60),
        backgroundColor: (props) => props.status.background,
        color: (props) => props.status.color,
        fontSize: 24,
        lineHeight: '30px',
        animation: (props) => (props.shouldShowReconnectingBanner ? '$slideIn 0.5s forwards' : '$slideOut 0.5s forwards'),
    },
    '@keyframes slideIn': {
        '0%': {
            top: -200,
            opacity: 0,
        },
        '100%': {
            top: (props) => props.top,
            opacity: 1,
        },
    },
    '@keyframes slideOut': {
        '0%': {
            top: (props) => props.top,
            opacity: 1,
        },
        '100%': {
            top: -200,
            opacity: 0,
        },
    },
}));
const getStatusInfo = (status) => {
    switch (status) {
        case 'offline':
            return {
                type: 'offline',
                background: '#DADCE0',
                color: '#000',
                translation: 'network.nowOffline',
            };
        case 'reconnecting':
            return {
                type: 'reconnecting',
                background: '#ED8822',
                color: '#fff',
                translation: 'network.reconnecting',
            };
        case 'online':
            return {
                type: 'online',
                background: '#34C54F',
                color: '#fff',
                translation: 'network.nowConnected',
            };
        default:
            return {
                type: 'online',
                background: '#34C54F',
                color: '#fff',
                translation: 'network.nowConnected',
            };
    }
};
const WebsocketReconnectingBanner = ({ className, electronCaptionMode, shouldShowReconnectingBanner, websocketStatus, }) => {
    const statusInfo = getStatusInfo(websocketStatus);
    let top = 0;
    if (window.isElectron) {
        top += isMac ? 28 : 32;
    }
    if (electronCaptionMode) {
        top = 0;
    }
    else {
        top += 68;
    }
    const classes = useStyles({
        electronCaptionMode,
        shouldShowReconnectingBanner,
        status: statusInfo,
        top,
    });
    const { t } = useTranslation();
    if (!shouldShowReconnectingBanner)
        return null;
    return (React.createElement("div", { className: classnames(classes.root, className) },
        React.createElement(LoadingText, { className: classnames({ [classes.ellipsis]: statusInfo.type === 'reconnecting' }) }, t(statusInfo.translation))));
};
const mapStateToProps = ({ scribeSession: { shouldShowReconnectingBanner, websocketStatus }, scribeTranscriptUI: { electronCaptionMode }, }) => ({
    electronCaptionMode,
    shouldShowReconnectingBanner,
    websocketStatus,
});
export default connect(mapStateToProps)(WebsocketReconnectingBanner);
